import calendar from "@/../../hypetrain/static/img/business-calendar.svg";
import coachingSessions from "@/../../hypetrain/static/img/pro-coaching-sessions.svg";
import importantQuestions from "@/../../hypetrain/static/img/pro-important-questions.svg";
import vetted from "@/../../hypetrain/static/img/vetted.svg";
import styled from "@emotion/styled";

import EmbedSvg from "@/components/helpers/ui/EmbedSvg";
import { Box, Flex } from "@/components/layout/flexbox";
import { breakpoints } from "@/components/layout/Media";
import { Container } from "@/components/pieces/bootstrap";
import {
  StyledSubtitle,
  StyledTitle,
} from "@/components/pieces/marketing/Titles";
import WhiteBar from "@/components/pieces/marketing/WhiteBar";
import LPLink from "@/components/pieces/upsell/LPLink";
import { BRAND_PURPLE, SUBTEXT_COLOR } from "@/css/constants";

export const StepList = [
  {
    title: "Choose from our world-class, vetted coaches",
    photo: vetted,
  },
  {
    title: "Instantly schedule a time that works for you",
    photo: calendar,
  },
  {
    title: "Meet 1:1 with your coach in digital sessions",
    photo: coachingSessions,
  },
  {
    title: "Message with your coach for effective accountability",
    photo: importantQuestions,
  },
];

function UXGrid({ items, title }) {
  return (
    <>
      <GridHeader fontSize={16} textAlign="center">
        {title}
      </GridHeader>
      <StyledGrid>
        {items.map((item, i) => {
          const { title, photo } = item;
          return (
            <GridItem className="grid-item" key={"item-grid-" + i}>
              <StyledIcon src={photo} />
              <Box pt={[0, 0, 3]} px={[0, 0, 4]} ml={[3, 3, 9]} fontSize={18}>
                {title}
              </Box>
            </GridItem>
          );
        })}
      </StyledGrid>
    </>
  );
}

export default function UserExperience({
  title = "A seamless, modern experience",
  subtitle = "World-class coaches. Incredible technology. Lasting change.",
  audience = "D2C",
  ctaLink = null,
  ctaText = null,
  onCtaClick = null,
}) {
  return (
    <WhiteBar>
      <Container>
        <Box mb={4}>
          <StyledTitle>{title}</StyledTitle>
          <StyledSubtitle>{subtitle}</StyledSubtitle>
        </Box>
        <StyledBox>
          <UXGrid
            title={
              audience === "D2C" ? "HOW IT WORKS" : "THE EMPLOYEE EXPERIENCE"
            }
            items={StepList}
          />
        </StyledBox>
        {ctaText ? (
          <Flex alignItems="center" flexDirection="column" mt={5}>
            <Box mb={3}>
              <LPLink
                onCtaClick={onCtaClick}
                to={ctaLink}
                color={BRAND_PURPLE}
                text={ctaText}
                style={{
                  width: 300,
                }}
              />
            </Box>
          </Flex>
        ) : null}
      </Container>
    </WhiteBar>
  );
}

const StyledBox = styled(Box)`
  background: white;
  border: 1px solid rgb(244, 241, 255);
  box-shadow: rgb(0 0 0 / 5%) 0px 4px 10px;
  border-radius: 10px;
`;

const GridItem = styled("div")`
  min-height: 195px;
  overflow: hidden;
  text-align: center;
`;

const StyledIcon = styled(EmbedSvg)`
  margin-bottom: 20px;
  max-height: 100px;
`;

const StyledGrid = styled(Flex)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  .grid-item {
    border-right: 0.5px solid rgb(244, 241, 255);
    padding: 20px 0;
  }

  @media screen and (max-width: ${breakpoints.md}px) {
    grid-template-columns: repeat(2, 1fr);

    .grid-item {
      display: flex;
      align-items: center;
      border-bottom: 0.5px solid rgb(244, 241, 255);
      padding: 20px;
      text-align: left;
      min-height: auto;

      img {
        width: 60px;
      }

      &:last-item {
        border-bottom: 0px;
      }
    }
  }
  @media screen and (max-width: ${breakpoints.sm}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const GridHeader = styled(Box)`
  border-bottom: 0.5px solid rgb(244, 241, 255);
  padding: 10px 0;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 5%);
  font-weight: 600;
  color: ${SUBTEXT_COLOR};
  letter-spacing: 1px;
`;
